module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom12.66281e49.jpg";